module.exports = __webpack_public_path__ + "assets/img/img-detail-bottom.eb7d92f6.jpg";